import { useEffect, useState } from "react";
import { errorNotify, sucessNotify } from "../../services/toast.notification";
import { ValidationErrorSpan } from "../../styles/global";
import { useForm } from "../../utility/useForm";
import { validateUpdatePasswordForm } from "../../utility/validationRules";
import { FormProps } from '../../utility/types';
import Spinner from "../../components/_common/Spinner";
import { Col, Modal, Row } from "antd";
import FormContainer from "../../components/FormContainer/FormContainer";
import { InfoText, PaymentGatewayContainer } from "../machineInstalRequest/styles";
import { billSingularPay, machineInstallManualPay, updateLabUserPassword, updateTaxInfo } from "../../api/api";
import CustomSelect from "../../components/_common/CustomSelect";
import { payTypes } from "../../constants";
import CustomTextArea from "../../components/_common/CustomTextArea";
import { useAppDispatch, useAppSelector } from "../../redux/store/storehooks";
import { loginAfterEnterTaxInfo, logout } from "../../redux/reducers/authSlice";
import Input from "../../components/_common/Input";

export const UpdatePasswordDialog: React.FC<FormProps> = ({visible,onSubmit,onCancel,payLoad,setShowDialog}) => {

    const { values, errors, handleChange, handleSubmit,setErrors,setValues } = useForm(validateUpdatePasswordForm) as any
    const myStore = useAppSelector((state) => state)
    const dispatch = useAppDispatch();
    const [isLoading,setIsLoading] = useState(false);
    const [isSubmiting,setIsSubmiting] = useState(false);

    const ValidationType = ({ type }: any) => {
        const ErrorMessage = errors[type]; 
        return (
            <ValidationErrorSpan erros={errors[type]}>{ErrorMessage}</ValidationErrorSpan>
        );
    };

    useEffect( ()=>{

    },[])



    const onSubmitForm = (e:any) => {
        e.preventDefault();

        console.log(values);
        console.log(payLoad.oldPassword.toString());

        if (!values.oldPassword){
            setErrors({oldPassword:"گذرواژه قدیمی وارد نشده است"})
            return;
        }

        if (values.newPassword.toString() === payLoad.oldPassword.toString()){
            setErrors({oldPassword:"گذرواژه قدیمی با جدید یکسان می باشد"})
            return;
        }

      
    
        let error= validateUpdatePasswordForm(values);
        if (Object.keys(error).length == 0)
        {
            setIsSubmiting(true)

            updateLabUserPassword(
                payLoad.labId,
                values.newPassword,
            ).then((result: any) => {
                    sucessNotify("پسورد شما با موفقیت تغییر یافت", undefined, 5000)
                    sucessNotify("مجددا به سیستم وارد شوید", undefined, 5000)
                    setIsSubmiting(false)
                    dispatch(logout())
                    onCancel();
            }).catch((error) => {
                    console.log(error);
                    setIsSubmiting(false)
                    dispatch(logout())
                    errorNotify(error.response.data.errorMessage, undefined, 5000)
            })
        }
        else
        {
            setErrors(error);
        }


       
    }

    return (
        <Modal
            visible={visible}
            onCancel={onCancel}
            cancelButtonProps={{ style: { display: 'none' } }}
            okButtonProps={{ style: { display: 'none' } }}
        >
            <>
                {isLoading === true && (
                            <Spinner/>
                )}

                {isLoading === false && (

                    <FormContainer title="تغییر گذرواژه" onSubmit={onSubmitForm} onCancel={() => setShowDialog(false)} isLoading={isLoading} isSubmiting={isSubmiting} >
                
                        <Row>
                            <Col lg={24} md={24} sm={24} xs={24}>
                                <Input
                                    name="oldPassword"
                                    placeholder="گذرواژه قبلی"
                                    value={values.oldPassword || ""}
                                    onChange={handleChange}
                                    type="password"
                                />
                                <ValidationType type="oldPassword" />
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={24} md={24} sm={24} xs={24}>
                                <Input
                                    name="newPassword"
                                    placeholder="گذرواژه جدید"
                                    value={values.newPassword || ""}
                                    onChange={handleChange}
                                    type="password"
                                />
                                <ValidationType type="newPassword" />
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={24} md={24} sm={24} xs={24}>
                                <Input
                                    name="repeatNewPassword"
                                    placeholder="تکرار گذرواژه جدید"
                                    value={values.repeatNewPassword || ""}
                                    onChange={handleChange}
                                    type="password"
                                />
                                <ValidationType type="repeatNewPassword" />
                            </Col>
                        </Row>

                    </FormContainer>

                )}
            </>
            
        </Modal>
    )
}